import { createFeatureSelector } from '@ngrx/store';

import { User } from '®shared/auth';
import {
  ModalControlsSaveable,
  ModalControlsSaveableFactory,
} from '®shared/modals';
import { ListItem } from '®shared/reading-list/models';
import { DcSettings } from '®shared/tenant/dc-settings';

import { RequestDigitisationIdentifier } from './request-digitisation-identifier';

export const STATE_FEATURE_REQUEST_DIGITISATION = 'requestDigitisation';

export interface RequestDigitisationState {
  currentItem: ListItem | null;
  modalControls: ModalControlsSaveable;
  requestDigitisationUrl: string | null;
  selectedIdentifier: RequestDigitisationIdentifier | null;
  user: User | null;
  dcSettings: DcSettings | null;
}

export const REQUEST_DIGITISATION_INITIAL_STATE: RequestDigitisationState = {
  currentItem: null,
  modalControls: ModalControlsSaveableFactory.hide(),
  requestDigitisationUrl: null,
  selectedIdentifier: null,
  user: null,
  dcSettings: null,
};

export function getInitialRequestDigitisationState(): RequestDigitisationState {
  return REQUEST_DIGITISATION_INITIAL_STATE;
}

export const selectRequestDigitisationState =
  createFeatureSelector<RequestDigitisationState>(
    STATE_FEATURE_REQUEST_DIGITISATION,
  );
